// extracted by mini-css-extract-plugin
module.exports = {"messageCol":"Table_messageCol__3ruLg","author":"Table_author__2j3OL","authorImage":"Table_authorImage__2pLlx","unreadRow":"Table_unreadRow__3nbzC"};